import { fetchWithAuth } from '../../../common/utils/apiUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

class TituloVigenteService {

    getMvtUrlTemplate() {
        return `${API_BASE_URL}/mvt/titulo-vigente/{z}/{x}/{y}`;
    }

    /**
     * Get all Titulos Vigentes as GeoJSON
     * @returns {Promise} GeoJSON FeatureCollection
     */
    async getAllTitulosVigentesGeoJson() {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/titulo-vigente/geojson`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return { data };
        } catch (error) {
            console.error('Error fetching Titulos Vigentes GeoJSON:', error);
            throw error;
        }
    }

    /**
     * Get all Titulos Vigentes
     * @returns {Promise} List of Titulos Vigentes
     */
    async getAllTitulosVigentes() {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/titulo-vigente`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching Titulos Vigentes:', error);
            throw error;
        }
    }

    /**
     * Get a Titulo Vigente by ID
     * @param {number} id - Titulo Vigente ID
     * @returns {Promise} Titulo Vigente
     */
    async getTituloVigenteById(id) {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/titulo-vigente/${id}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching Titulo Vigente by ID:', error);
            throw error;
        }
    }

    /**
     * Get a Titulo Vigente by CODIGO_EXP
     * @param {string} codigoExp - Titulo Vigente code
     * @returns {Promise} Titulo Vigente
     */
    async getTituloVigenteByCodigoExp(codigoExp) {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/titulo-vigente/codigo-exp/${encodeURIComponent(codigoExp)}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching Titulo Vigente by CODIGO_EXP:', error);
            throw error;
        }
    }

    /**
     * Upload GeoJSON file with Titulos Vigentes
     * @param {Object} geoJsonData - Complete GeoJSON object
     * @returns {Promise} Response with saved Titulos Vigentes
     */
    async uploadGeoJson(geoJsonData) {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/titulo-vigente/upload`, {
                method: 'POST',
                body: JSON.stringify(geoJsonData)
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return { data };
        } catch (error) {
            console.error('Error uploading GeoJSON:', error);
            throw error;
        }
    }

    /**
     * Delete all Titulos Vigentes
     * @returns {Promise} Deletion confirmation
     */
    async deleteAllTitulosVigentes() {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/titulo-vigente`, {
                method: 'DELETE'
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error deleting Titulos Vigentes:', error);
            throw error;
        }
    }

    /**
     * Convert Titulos Vigentes to GeoJSON format for map libraries
     * @param {Array} titulos - Array of Titulos Vigentes from backend
     * @returns {Object} GeoJSON FeatureCollection
     */
    convertToGeoJSON(titulos) {
        return {
            type: 'FeatureCollection',
            features: titulos.map(titulo => ({
                type: 'Feature',
                properties: {
                    id: titulo.id,
                    fid: titulo.fid,
                    codigoExp: titulo.codigoExp,
                    tituloEst: titulo.tituloEst,
                    modalidad: titulo.modalidad,
                    municipios: titulo.municipios,
                    departamen: titulo.departamen,
                    areaHa: titulo.areaHa,
                    clasificac: titulo.clasificac,
                    etapa: titulo.etapa,
                    minerales: titulo.minerales
                },
                geometry: this.parseGeometry(titulo.geometry)
            }))
        };
    }

    /**
     * Parse geometry string to GeoJSON
     * @param {string|Object} geometry - Geometry from backend
     * @returns {Object} Geometry in GeoJSON format
     */
    parseGeometry(geometry) {
        if (!geometry) {
            return null;
        }
        
        if (typeof geometry === 'string') {
            try {
                return JSON.parse(geometry);
            } catch (e) {
                console.error('Error parsing geometry:', e);
                return null;
            }
        }
        
        return geometry;
    }
}

export default new TituloVigenteService();
